import { MIN_ZOOM, ZoomLevel } from "@zapier/canvas-constants";

export default function getNextZoomOutLevel(
  currentZoom: number,
  zoomLevels: ZoomLevel[],
): ZoomLevel {
  const possibleLevels = zoomLevels.filter((level) => level < currentZoom);
  return (
    possibleLevels.length > 0 ? Math.max(...possibleLevels) : MIN_ZOOM
  ) as ZoomLevel;
}
